




















import { container } from 'tsyringe';
import { onActivated, onDeactivated, onMounted, onUnmounted, defineComponent, ref, watch } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import LoadingAnimation from '@/components/LoadingAnimation.vue';
import TextBubble from '@/components/TextBubble.vue';
import AudioPlayer from '@/prototyping/audio-player/Container.vue';
import { ModelManager } from '@/prototyping/model';
import { messenger } from '@/messenger';
import { JsonRpcMessage } from '@/messenger/jrpc/message';
import { ChannelSubscription } from '@/messenger/core/channel';

export default defineComponent({
  components: { ViewContainer, LoadingAnimation, TextBubble, AudioPlayer },
  name: 'ARManualPlacement',
  props: { objectName: { type: String, required: false } },
  setup(props) {
    const loaded = ref(false);
    let planeDetectedSubscription: undefined | ChannelSubscription;
    let placeholderEnabledSubscription: undefined | ChannelSubscription;

    enum State {
      NOPLANESDETECTED,
      PLACEHOLDERINACTIVE,
      PLACEHOLDERACTIVE,
      OBJECTPLACED,
    }
    const currentState = ref(State.NOPLANESDETECTED);

    async function enableARandManualPlacement() {
      try {
        await messenger.unity?.scene.initializeAR();
        await messenger.unity?.scene.loadScene('ARManualPlacementScene');
      } catch (e) {
        console.error(e);
      }
    }

    async function disableARandManualPlacement() {
      try {
        await messenger.unity?.scene.loadScene('VinylPostcardsLoadingScene');
        await messenger.unity?.scene.deinitializeAR();
      } catch (e) {
        console.error(e);
      }
    }

    async function handleTap() {
      try {
        await messenger.unity?.ar.placeObject();
        currentState.value = State.OBJECTPLACED;
      } catch (e) {
        console.error(e);
      }
      console.log('tap');
    }

    function callbackFoundPlane() {
      if (currentState.value === State.NOPLANESDETECTED) currentState.value = State.PLACEHOLDERINACTIVE;
      console.log('foundPlane');
    }

    function callbackPlaceholderEnabled(rpcMessageWithBoolEnabled: JsonRpcMessage) {
      let enabled = false;
      if (rpcMessageWithBoolEnabled.params) {
        if (Array.isArray(rpcMessageWithBoolEnabled.params)) {
          if (rpcMessageWithBoolEnabled.params.length === 1) {
            enabled = rpcMessageWithBoolEnabled.params[0] as boolean;
          }
        } else {
          enabled = rpcMessageWithBoolEnabled.params.enabled as boolean;
        }
      }
      currentState.value = enabled ? State.PLACEHOLDERACTIVE : State.PLACEHOLDERINACTIVE;
    }

    async function initScene() {
      if (!loaded.value) {
        planeDetectedSubscription = messenger.unity?.ar.channel.subscribe('planeDetected', callbackFoundPlane);
        placeholderEnabledSubscription = messenger.unity?.ar.channel.subscribe('placeholderEnabled', callbackPlaceholderEnabled);
        await enableARandManualPlacement();
        loaded.value = true;
        if (props.objectName) messenger.unity?.ar.setObject(props.objectName);
      }
    }

    function unloadScene() {
      if (loaded.value) {
        loaded.value = false;
        disableARandManualPlacement().catch((e) => console.error(e));
        planeDetectedSubscription?.unsubscribe();
        placeholderEnabledSubscription?.unsubscribe();
        currentState.value = State.NOPLANESDETECTED;
      }
    }

    onActivated(initScene);
    onMounted(initScene);

    onDeactivated(unloadScene);
    onUnmounted(unloadScene);

    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');

    watch(audioPlayer.isPlaying, async () => {
      try {
        if (audioPlayer.isPlaying.value !== undefined) await messenger.unity?.vinylPostcards.changePlayingState(audioPlayer.isPlaying.value);
      } catch (e) {
        console.error(e);
      }
    });

    watch(audioPlayer.currentAudioTrack, async (val, oldVal) => {
      try {
        if (val?.src !== oldVal?.src && val !== undefined) await messenger.unity?.vinylPostcards.changeAudioCover(val.src as string);
      } catch (e) {
        console.error(e);
      }
    });

    return {
      loaded,
      handleTap,
      currentState,
      State,
    };
  },
});
